import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import anyStatusSlice from "./features/anyStatus/anyStatus.Slice";
import appSlice from "./features/appSlice";
import loginSlice from "./features/auth/loginSlice";
import categorySlice from "./features/category/categorySlice";
import communityForumDataSlice from "./features/communityForum/communityForumSlice";
import contentManagementSlice from "./features/contentManagment/contentManagmentSlice";
import csoRoleSlice from "./features/csoManager/role/roleSlice";
import csoUserSlice from "./features/csoManager/user/userSlice";
import dashboardSlice from "./features/dashboard/dashboardSlice";
import discussionBoardSlice from "./features/discussionBoard/discussionBoardSlice";
import donationSlice from "./features/donation/donationSlice";
import manageCampaignSlice from "./features/EventManage/Campaigns/CampaignSlice";
import manageEventSlice from "./features/EventManage/Event/eventSlice";
import pendingRequestSlice from "./features/EventManage/PendingRequest/pendingRequestSlice";
import manageWebinarSlice from "./features/EventManage/Webinars/webinarsSlice";
import regionalHubSlice from "./features/geo/createGeo/regionSlice";
import divisionSlice from "./features/geo/division/divisionSlice";
import districtSlice from "./features/geo/district/districtSlice";
import getGeoSlice from "./features/geo/getGeo/getGeoSlice";
import settingsSlice from "./features/settings/settingsSlice";
import trainingMaterialSlice from "./features/trainingMaterial/trainingMaterialSlice";
import awardsSlice from "./features/webCms/aboutUs/awards/awardsSlice";
import becomePartnerSlice from "./features/webCms/aboutUs/becomePartner/becomePartnerSlice";
import contributionSlice from "./features/webCms/aboutUs/contribution/contributionSlice";
import governanceSlice from "./features/webCms/aboutUs/governance/becomePartnerSlice";
import LeaderShipSlice from "./features/webCms/aboutUs/leadership/leaderShipSlice";
import missionAndVisionSlice from "./features/webCms/aboutUs/mission/missionSlice";
import partnershipSlice from "./features/webCms/aboutUs/partnership/partnerShipSlice";
import weWorkSlice from "./features/webCms/aboutUs/weWork/weWorkSlice";
import aboutSushilSlice from "./features/webCms/cmsHome/aboutSushil/aboutSushilSlice";
import ourReachSlice from "./features/webCms/cmsHome/ourReach/ourReachSlice";
import sliderSlice from "./features/webCms/cmsHome/slider/sliderSlice";
import socialMediaSlice from "./features/webCms/cmsHome/socialMedia/socialSlice";
import footerUpdateSlice from "./features/webCms/footer/footerSlice";
import galleryDataSlice from "./features/webCms/gallery/gallerySlice";
import headerUpdateSlice from "./features/webCms/header/headerSlice";
import notificationReducer from './features/notification/notificationSlice';

export const store = configureStore({
  reducer: {
    app: appSlice.reducer,
    getGeo: getGeoSlice.reducer, // common
    category: categorySlice.reducer, // common
    regionalHub: regionalHubSlice.reducer, // common
    division: divisionSlice.reducer,
    district: districtSlice.reducer,
    updateAnyStatus: anyStatusSlice.reducer, // common
    dashboard: dashboardSlice.reducer,
    role: csoRoleSlice.reducer,
    user: csoUserSlice.reducer,
    event: manageEventSlice.reducer,
    webinar: manageWebinarSlice.reducer,
    pendingRequest: pendingRequestSlice.reducer,
    campaigns: manageCampaignSlice.reducer,
    publication: contentManagementSlice.reducer,
    donation: donationSlice.reducer,
    userDetails: settingsSlice.reducer,
    trainingMaterial: trainingMaterialSlice.reducer,
    communityForum: communityForumDataSlice.reducer,
    discussionBoard: discussionBoardSlice.reducer,
    webCmsSlider: sliderSlice.reducer,
    webCmsAboutSushil: aboutSushilSlice.reducer,
    webCmsOurReach: ourReachSlice.reducer,
    webCmsSocialMedia: socialMediaSlice.reducer,
    webCmsMissionVision: missionAndVisionSlice.reducer,
    webCmsLeaderShip: LeaderShipSlice.reducer,
    webCmsWeWork: weWorkSlice.reducer,
    webCmsFooter: footerUpdateSlice.reducer,
    webCmsPartnership: partnershipSlice.reducer,
    webCmsBecomePartner: becomePartnerSlice.reducer,
    webCmsContribution: contributionSlice.reducer,
    webCmsGovernance: governanceSlice.reducer,
    webCmsAward: awardsSlice.reducer,
    webCmsHeader: headerUpdateSlice.reducer,
    webCmsGallery: galleryDataSlice.reducer,

    login: loginSlice.reducer,
    notification: notificationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
